<div class="EfItineraryStopCardComponent card {{ disabled ? 'EfItineraryStopCardComponent--Disabled': '' }} {{ full ? 'EfItineraryStopCardComponent--Full': '' }}" (click)="onCardClick()">
    @if (stopData != null) {
        @if (stopData.loading) {
            <app-pg-loading></app-pg-loading>
        }
        @if (!stopData.loading) {
            @if (stopData.error) {
                <div class="card-body text-center">
                    <div class="alert alert-danger">
                        <div class="mb-3">
                            <i class="fa-regular fa-exclamation-triangle fa-3x"></i>
                        </div>
                        <div>
                            {{ 'experience-finder.ef-itinerary-stop.product-error' | locTranslate }}
                        </div>
                    </div>
                </div>
            }
            @if (!stopData.error) {
                <div [hidden]="showSource" class="EfItineraryStopCardComponent-Main">
                    @if (stopData.day != null) {
                        <div class="EfItineraryStopCardComponent-Header p-2 {{singleDay ? 'opacity-00' : ''}}">
                            <div class="badge bg-white text-dark">
                                {{ 'experience-finder.ef-itinerary-stop.day' | locTranslate }} {{stopData.day}}
                            </div>
                        </div>
                    }
                    <div class="EfItineraryStopCardComponent-Image">
                        <div class="card-img-top">
                            @if (getCoverImage(); as image) {
                                <div>
                                    <app-pg-image-autosize [src]="image" fit="cover"></app-pg-image-autosize>
                                </div>
                            }
                            @if (!getCoverImage()) {
                                <div class="bg-light text-white d-flex justify-content-center align-items-center">
                                    <i class="fa-regular fa-image fa-8x"></i>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="EfItineraryStopCardComponent-Content">
                        <div class="card-body">
                            <div class="EfItineraryStopCardComponent-Content-Inner mb-2">
                                <h3 class="card-title h5 mb-2">
                                    <span [innerHTML]="getTranslatedProperty('title')"></span>
                                </h3>

                                @if (full && stopData.resource != 'External') {
                                    <div class="mb-2">
                                        <app-ef-product-location [productData]="stopData"></app-ef-product-location>
                                    </div>
                                }

                                <div class="card-text text-muted" [innerHTML]="getTranslatedProperty('text') | safe:'html'"></div>
                            </div>

                            <div class="EfItineraryStopCardComponent-Info EfItineraryStopCardComponent-Info--Footer">
                                @if (stopData.resource != 'External') {
                                    <div class="d-flex justify-content-between align-items-baseline w-100">
                                        <div>
                                            <span class="badge text-white" [style.backgroundColor]="getTypeColor()">
                                                <i class="fa-regular" [innerHTML]="getTypeIcon()"></i>
                                                <span class="ms-2">{{getTypeText()}}</span>
                                            </span>
                                        </div>
                                        @if (full && productData) {
                                            <div>
                                                <button class="btn btn-link btn-sm p-0 border-0" (click)="setShowSource(true)">
                                                    <span [innerHTML]="productData.getTranslatedProductField('title')"></span>
                                                    <i class="fa-regular fa-chevron-right"></i>
                                                </button>
                                            </div>
                                        }
                                    </div>
                                }
                                @if (stopData.resource == 'External') {
                                    <a class="EfItineraryStopCardComponent-Info-ExternalLink" target="_blank" [href]="stopData.element | safe:'url'">
                                        <i class="fa-regular fa-arrow-up-right-from-square me-2 fa-sm"></i>
                                        <span>{{stopData.element}}</span>
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                    @if (full && additionalPoIs != null && additionalPoIs.length > 0) {
                        <div class="EfItineraryStopCardComponent-Content-AdditionalPoIs my-2">
                            @if (isLoadingAdditionalPoIs) {
                                <app-pg-loading [isOverlay]="true"></app-pg-loading>
                            }
                            <div #gmapsElement [hidden]="isLoadingAdditionalPoIs"></div>
                        </div>
                        <ol class="mb-2">
                            @for (poi of additionalPoIs; track poi) {
                                <li>
                                    {{ poi.getTranslatedProductField('name') }}
                                </li>
                            }
                        </ol>
                    }
                </div>
                @if (showSource) {
                    <div class="EfItineraryStopCardComponent-Source">
                        <div class="p-4 pb-3 mx-1">
                            <button class="btn btn-link btn-sm p-0 border-0" (click)="setShowSource(false)">
                                <i class="fa-regular fa-chevron-left"></i>
                                <span>{{ 'experience-finder.ef-itinerary-stop.back-to-stop' | locTranslate }}</span>
                            </button>
                        </div>
                        @if (isLoadingSource) {
                            <app-pg-loading></app-pg-loading>
                        }
                        @if (!isLoadingSource) {
                            <app-ef-product [productData]="productData" [supplierData]="supplierData" [appMode]="appMode" [disableBooking]="true"></app-ef-product>
                        }
                    </div>
                }
            }
        }
    }
</div>